import { useEffect, useState } from "react";
import MaterialTable, { MTableAction } from "material-table";
import { Box, Button, Chip, CircularProgress, IconButton, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Base from "../../../Base/views/Base";
import Popup from "../../../Base/views/Popup";
import { GetMprRequestsAction, UpdateApproverMprRequestsAction } from "../../../../../store/ATS/MprRequest/Action";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import AddMPRPopup from "./AddMPRPopup";
import { MprStatusRenderer, getStatusColor } from "./MprStatusRenderer";
import { PowerUserDisabledAction } from "../../../../../store/RoleAccess/Permission/Action";
import { AddMenuHeadingAction } from "../../../../../store/Menu/Action";
import history from "../../../../../history";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import { downloadMprAsDoc } from "../../helper/AtsMprDocDownloadHelper";
import {LabelWithInfo} from "../../../Base/views/LabelwithInfo";
import {ConvertDateTime} from "../../../Base/helper/baseFunctions";
import { toast } from "react-toastify";
import { getMprPendingApproverInfo, triggerMprReminderEmailHelper } from "../../helper/AtsMprRequestHelper";

const RequestsTab = () => {
    const dispatch = useDispatch();
    const { mpr_requests_data, isLoadingMprRequests } = useSelector((state) => state?.AtsReducer?.MprRequestReducer || {});
    const { company_logo } = useSelector((state) => state?.AncillaryReducer?.LetterHeadReducer || {});
    const [openPopup, setOpenPopup] = useState(false);
    const [editedRecord, setEditedRecord] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [currentData, setCurrentData] = useState(null);
    const [isSendingReminder, setIsSendingReminder] = useState(false);

    const handleAddExpenses = () => {
        setOpenPopup(true);
    };
    const handleEdit = (rowData) => {
        setEditedRecord(rowData);
        setOpenPopup(true);
    };
    const closeMode = (resetForm) => {
        setIsSendingReminder(false);
        setEditedRecord(null);
        setOpenPopup(false);
    };
    const handleSendReminder = async (record) => {
        if (!record || isSendingReminder) return;
        setIsSendingReminder(true);
        try {
            await triggerMprReminderEmailHelper({
                record,
                companyLogo: company_logo,
            });
        } catch (error) {
            console.error("handleSendReminder error:", error);
            toast.error("Failed to send reminder email");
        } finally {
            setIsSendingReminder(false);
        }
    };
    const handleConfirmDelete = (rowData) => {
        setOpenDialog(true);
        setCurrentData(rowData);
    };
    const handleDelete = () => {
        setOpenDialog(false);
        const payload = {
                    mpr_request_fk: currentData?.mpr_requests_pk,
                    status: "Cancelled",
                    approved_positions_count: null,
                    mpr_metadata_json: JSON.stringify({
                        first_status: "Cancelled",
                        first_comment: "",
                        second_status: "Cancelled",
                        second_comment: "",
                        third_status: "Cancelled",
                        third_comment: "",
                    })
                };
                dispatch(UpdateApproverMprRequestsAction(payload, (res, err) => {
                    if (res && !err) {
                        dispatch(GetMprRequestsAction());
                        setCurrentData(null);
                    }
                }));
    };
    useEffect(() => {
        dispatch(GetMprRequestsAction());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
 
    // has authorization to create job
  const { featuresData } = useSelector(
    (state) => state?.RoleAndAccessReducer?.ATSModuleFeaturesReducer
  );
  const handleDisabled = () => {
    let value = featuresData?.filter(
      (row) => row?.permission === "dashboard_add_jobpost"
    );
    return value?.length > 0 ? true : false;
  };
  const handleCreateJob = (mprData) => {
    if (handleDisabled()) {
        dispatch(PowerUserDisabledAction())
    } else {
        sessionStorage.setItem("selectedMenu", "Add Job")
        dispatch(AddMenuHeadingAction({ heading: "Add Job" }))
        history.push({
            pathname: "/ats/add-job/",
            state: { from: "mpr_request", mpr_data: { ...mprData }},
        })                  
    }  
  }
    return (
        <Base>
            <Box sx={{ height: "calc(100vh - 65px)", overflowY: "auto", mt: 1 }}>
                <Box>
                    <MaterialTable
                        isLoading={isLoadingMprRequests}
                        onRowClick={(event, rowData) => handleEdit(rowData)}
                        columns={[
                            {
                                title: "MPR ID",
                                field: "mpr_no",
                                cellStyle: { padding: "7px 0px 7px 10px" },
                                headerStyle: { padding: "5px 0px 5px 10px" },
                            },
                            {
                                title: "Designation",
                                field: "role",
                                cellStyle: { padding: "7px 0px 7px 10px" },
                                headerStyle: { padding: "5px 0px 5px 10px" },
                            },
                            {
                                title: "Department",
                                field: "bu_name",
                                cellStyle: { padding: "7px 0px 7px 10px" },
                                headerStyle: { padding: "5px 0px 5px 10px" },
                                render: (rowData) => rowData?.bu_name
                            },
                            // {
                            //     title: "Location",
                            //     field: "location",
                            //     cellStyle: { padding: "7px 0px 7px 10px" },
                            //     headerStyle: { padding: "5px 0px 5px 10px" },
                            // },
                            {
                                title: "Requested Headcount",
                                field: "headcount",
                                align: "center",
                                cellStyle: { padding: "7px 0px 7px 10px" },
                                headerStyle: { padding: "5px 0px 5px 10px" },
                            },
                            {   title: "Approved Headcount", 
                                field: "approved_headcount", 
                                align: "center",
                                cellStyle: { padding: "7px 0px 7px 10px" },
                                headerStyle: { padding: "5px 0px 5px 10px" },
                                render: rowData => rowData?.approved_headcount || "-" 
                            },
                            {   title: "Headcount Filled", 
                                field: "filled", 
                                align: "center",
                                cellStyle: { padding: "7px 0px 7px 10px" },
                                headerStyle: { padding: "5px 0px 5px 10px" },
                                render: rowData => rowData?.filled || "-" 
                            },
                            {
                                title: "Requested Budget",
                                field: "max_budget",
                                align: "right",
                                cellStyle: { padding: "7px 20px 7px 10px" },
                                headerStyle: { padding: "5px 20px 5px 10px" },
                                render: (rowData) => {
                                    if (!rowData?.is_budgeted) return "Non Budgeted";
                                    return rowData?.max_budget ? rowData.max_budget : "N/A";
                                },
                            },
                            {
                                title: "Approved Budget",
                                field: "approved_budget",
                                align: "right",
                                cellStyle: { padding: "7px 20px 7px 10px" },
                                headerStyle: { padding: "5px 20px 5px 10px" },
                                render: (rowData) => {
                                    if (!rowData?.is_budgeted) return "Non Budgeted";
                                    const val = rowData?.approved_budget ?? rowData?.approver_budget ?? rowData?.budget;
                                    return val !== null && val !== undefined && val !== "" ? val : "N/A";
                                }
                            },
                            {
                                title: "Requested By",
                                field: "mpr_owner_name",
                                cellStyle: { padding: "7px 0px 7px 10px" },
                                headerStyle: { padding: "5px 0px 5px 10px" },
                                render: rowData => rowData?.mpr_owner_name && rowData?.createdon ? (  
                                    <LabelWithInfo variant="body1" props={{infoSize: 18}} 
                                    label={rowData?.mpr_owner_name} tooltip={`Requested On: ${ConvertDateTime(rowData?.createdon)}`} />
                                ) : rowData?.mpr_owner_name ? rowData?.mpr_owner_name : "-"
                            },
                            {
                                title: "Status",
                                field: "mpr_status",
                                cellStyle: { padding: "7px 0px 7px 0px" },
                                headerStyle: { padding: "5px 0px 5px 10px" },
                                render: (rowData) => <MprStatusRenderer rowData={rowData} />,
                            },
                            {
                                title: "Actions",
                                field: "actions",
                                headerStyle: { padding: "5px 0px 5px 10px", textAlign: "center" },
                                sorting: false,
                                render: (rowData) => {
                                    const isCreateJobDisabled = rowData?.mpr_status !== "Approved" || (+rowData?.approved_headcount > 0 && +rowData?.approved_headcount === +rowData?.filled);
                                    
                                    return(
                                    <Box sx={{display: "flex", alignItems: "center", gap: "4px", width: "140px"}}>
                                        {/* <IconButton
                                            sx={{ padding: "0px" }}
                                            onClick={() => handleEdit(rowData)}
                                        >
                                            <EditIcon />
                                        </IconButton> */}
                                        <Tooltip title={getDeleteMprTooltip(rowData)} arrow>
                                           <span>
                                            <IconButton
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    handleConfirmDelete(rowData);
                                                }}
                                                disabled={rowData?.mpr_status === "Cancelled" || rowData?.is_utilised}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                          </span>
                                        </Tooltip>

                                        <Tooltip title={getCreateJobTooltip(rowData)}>
                                            <span>
                                                <Button
                                                    variant="text"
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        handleCreateJob(rowData);
                                                    }}
                                                    disabled={isCreateJobDisabled} 
                                                >
                                                    + Create Job
                                                </Button>
                                            </span>
                                        </Tooltip>
                                    </Box>)
                                },
                            },
                        ]}
                        data={mpr_requests_data || []}
                        options={{
                            maxBodyHeight: "calc(100vh - 225px)",
                            minBodyHeight: "calc(100vh - 225px)",
                            rowStyle: {
                                fontSize: "13px",
                                height: "45px",
                            },
                            headerStyle: {
                                padding: "7px 10px 7px 10px",
                                fontWeight: "bold",
                            },
                            cellStyle: {
                                padding: "5px 0px 5px 13px",
                            },
                            sorting: true,
                            search: true,
                            searchFieldAlignment: "right",
                            searchAutoFocus: false,
                            filtering: false,
                            paging: true,
                            pageSizeOptions: [25, 50],
                            pageSize: 25,
                            selection: false,
                            actionsColumnIndex: -1,
                            grouping: false,
                            columnsButton: false,
                            showTitle: true,
                            exportAllData: false,
                            exportButton: false,
                        }}
                        actions={[
                            {
                                icon: () => (
                                    <Box
                                        id="filters"
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            px: 1,
                                        }}
                                    >
                                        <Button
                                            sx={{
                                                fontWeight: 700,
                                                borderRadius: "8px",
                                                fontSize: "13px",
                                                padding: "4px 6px",
                                                boxShadow: "none",
                                                marginRight: "8px",
                                            }}
                                            size="small"
                                            variant="contained"
                                            className="mpl-primary-btn"
                                            onClick={() => handleAddExpenses()}
                                        >
                                            + Add MPR
                                        </Button>
                                    </Box>
                                ),
                                isFreeAction: true,
                            },
                        ]}
                        components={{
                            Action: (props) => {
                                const ActionComponent =
                                    props?.components?.Action || MTableAction;
                                if (
                                    props?.action?.icon &&
                                    typeof props?.action?.icon === "function"
                                ) {
                                    const IconElement = props?.action?.icon();
                                    // Check if the rendered element is CustomToggle
                                    if (IconElement?.props?.id === "filters") {
                                        return (
                                            <Box
                                                sx={{
                                                    "& .MuiIconButton-root": {
                                                        background: "transparent !important",
                                                        boxShadow: "none !important",
                                                        padding: "0px !important",
                                                        margin: "0px !important",
                                                        borderRadius: "0px !important",
                                                        "&:hover": {
                                                            background: "transparent !important",
                                                        },
                                                    },
                                                    "& .MuiTouchRipple-root": {
                                                        display: "none",
                                                    },
                                                }}
                                            >
                                                <ActionComponent {...props} />
                                            </Box>
                                        );
                                    }
                                }
                                return <ActionComponent {...props} />;
                            },
                        }}
                        title=""
                    />
                </Box>
                <Popup
                    title={
                        editedRecord ? (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                <span>{editedRecord?.mpr_no ? `Preview MPR - ${editedRecord.mpr_no}` : "Preview MPR"}</span>
                                {editedRecord?.mpr_status && (
                                    <Chip
                                        label={editedRecord.mpr_status}
                                        size="small"
                                        style={{
                                            backgroundColor: getStatusColor(editedRecord.mpr_status).bg,
                                            color: getStatusColor(editedRecord.mpr_status).text,
                                            fontWeight: 600,
                                            fontSize: "12px",
                                            height: "22px",
                                        }}
                                    />
                                )}
                            </Box>
                        ) : "Add MPR"
                    }
                    openPopup={openPopup}
                    setOpenPopup={closeMode}
                    fullWidth={true}
                    maxWidth="md"
                    headerActions={
                        editedRecord ? (
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                {getMprPendingApproverInfo(editedRecord) && (
                                    <Tooltip
                                        title={`Send Reminder to ${
                                            getMprPendingApproverInfo(editedRecord)?.name || "Approver"
                                        }`}
                                    >
                                        <span>
                                            <IconButton
                                                disabled={isSendingReminder}
                                                onClick={() => handleSendReminder(editedRecord)}
                                                sx={{ m: 0, p: 0.5, pt: 0, mr: 0.5 }}
                                            >
                                                {isSendingReminder ? (
                                                    <CircularProgress size={18} color="inherit" disableShrink/>
                                                ) : (
                                                    <NotificationsActiveOutlinedIcon color="action" />
                                                )}
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                )}
                                <Tooltip title="Download as DOCX">
                                    <IconButton
                                        onClick={() => downloadMprAsDoc(editedRecord)}
                                        sx={{ m: 0, p: 0.5, pt: 0, mr: 0.5 }}
                                    >
                                        <FileDownloadOutlinedIcon color="action" />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        ) : null
                    }
                >
                    <AddMPRPopup
                        setOpenPopup={setOpenPopup}
                        editedRecord={editedRecord}
                        closeMode={closeMode}
                    />
                </Popup>
                <ConfirmationDialog
                    title="Cancel MPR Request?"
                    openDialog={openDialog}
                    closeDialog={setOpenDialog}
                    content={ currentData?.mpr_status === "Approved" ? "This MPR may be linked to hiring activities. Please ensure it is not in use before cancelling." : "Are you sure you want to cancel this MPR?"}
                    OkButtonText="Cancelled"
                    onSubmit={handleDelete}
                />
            </Box>
        </Base>
    );
};
const getCreateJobTooltip = (rowData) => {
  if (rowData?.mpr_status !== "Approved") {
    return "Only approved MPRs can be used to create a job.";
  }
  if (
    +rowData?.approved_headcount > 0 &&
    +rowData?.approved_headcount === +rowData?.filled
  ) {
    return "The approved hiring requirement has been fully filled.";
  }

  return "";
};
const getDeleteMprTooltip = (rowData) => {
  if (rowData?.mpr_status === "Cancelled") {
    return "";
  }

  if (rowData?.is_utilised) {
    return "This MPR cannot be cancelled because it is mapped to a job.";
  }

  return "Cancel this MPR";
};
export default RequestsTab;